import React from 'react'
import { Trans } from '@lingui/react'
import ModalTopBar from './ModalTopBar'
import Modal, { ModalMainContainer } from './Modal'
import ModalConfirmButtonBar from './ModalConfirmButtonBar'

const ModalExpiredToken = ({ logout, isOpen }) => (
    <Modal
        data-testid="UnauthorizedModal"
        ariaLabel="unauthorized"
        isOpen={isOpen}
    >
        <ModalTopBar title={<Trans id="Login required" />} />
        <ModalMainContainer>
            <Trans id="Please login again to keep working with Lexor" />
        </ModalMainContainer>
        <ModalConfirmButtonBar
            withSecondaryButton={false}
            onSubmit={() => logout()}
            submitText={<Trans id="Login again" />}
        />
    </Modal>
)

export default ModalExpiredToken
